import { initializeApp, getApps, getApp } from 'firebase/app'
import { getMessaging, getToken } from 'firebase/messaging'
import firebaseConfig from 'configs/FirebaseConfig'
import { VAPID_KEY } from 'configs/AppConfig'

const app = getApps().length ? getApp() : initializeApp(firebaseConfig)
const messaging = getMessaging(app)

export { app, messaging, getToken }

export const requestFCMToken = async () => {
  try {
    const permission = await Notification.requestPermission()

    if (permission !== 'granted') {
      throw new Error('Notification permission not granted.')
    }

    const token = await getToken(messaging, { vapidKey: VAPID_KEY })

    if (token) {
      return token
    }

    throw new Error('Failed to retrieve FCM token.')
  } catch (error) {
    console.error('Error getting FCM token: ', error)
    throw error
  }
}
